import AnnualInterview from "./AnnualInterview";
import CorporateLife from "components/workers/CorporateLife";
import EvaluationProject from "./EvaluationProject";
import ExternalTraining from "./ExternalTraining";
import GeneralInfoForm from "./GeneralInfoForm";
import InternalTraining from "./InternalTraining";
import SalaryEvolution from "./SalaryEvolution";
import SatisfactionBalance from "./SatisfactionBalance";
import { CONSULTANT_GENERAL_INFO_DEFAULT_VALUES } from "constants/forms";
import { ENTITY } from "constants/info-header";
import { useForm } from "react-hook-form";
import { useSalariesDatatrackContext } from "api/datatrack/salary/SalariesDatatrackProvider";
import PropTypes from "prop-types";
import SixYearReview from "./SixYearReview";

const DashboardConsultant = ({
  consultantBySlug,
  userScope,
  personEvaluations,
  currencyListByBranch,
  currencyListByBranchGetter,
  readOnly,
  filteredCorporateLife,
  consultantSixYearsReview,
  downloadReviewFile,
}) => {
  const {
    getStatsHistorySalaryByPersonId,
    statsHistorySalaryByPersonId,
    statsHistorySalaryByPersonIdStatus,
    statsHistorySalaryByBranchesStatus,
  } = useSalariesDatatrackContext();

  const { control, register, setValue, watch } = useForm({
    defaultValues: CONSULTANT_GENERAL_INFO_DEFAULT_VALUES,
  });
  return (
    <>
      <GeneralInfoForm
        control={control}
        register={register}
        setValue={setValue}
        watch={watch}
      />
      <SalaryEvolution
        readOnly={readOnly}
        control={control}
        register={register}
        setValue={setValue}
        watch={watch}
        getStatsHistorySalaryByPersonId={getStatsHistorySalaryByPersonId}
        statsHistorySalaryByPersonId={statsHistorySalaryByPersonId}
        statsHistorySalaryByPersonIdStatus={statsHistorySalaryByPersonIdStatus}
        statsHistorySalaryByBranchesStatus={statsHistorySalaryByBranchesStatus}
        currencyListByBranch={currencyListByBranch}
        currencyListByBranchGetter={currencyListByBranchGetter}
      />
      {consultantSixYearsReview?.length > 0 && (
        <SixYearReview
          consultantBySlug={consultantBySlug}
          consultantSixYearsReview={consultantSixYearsReview}
          downloadReviewFile={downloadReviewFile}
        />
      )}
      <AnnualInterview
        consultantBySlug={consultantBySlug}
        userScope={userScope}
        personEvaluations={personEvaluations}
      />
      <EvaluationProject />
      <InternalTraining />
      <ExternalTraining />
      <CorporateLife
        status={ENTITY.CONSULTANT}
        filteredCorporateLife={filteredCorporateLife}
      />
      <SatisfactionBalance />
    </>
  );
};

export default DashboardConsultant;

DashboardConsultant.propTypes = {
  consultantBySlug: PropTypes.object,
  userScope: PropTypes.string,
  personEvaluations: PropTypes.object,
  currencyListByBranch: PropTypes.object,
  currencyListByBranchGetter: PropTypes.func,
  readOnly: PropTypes.bool,
  downloadReviewFile: PropTypes.func,
  consultantSixYearsReview: PropTypes.array,
};
